module.exports = __webpack_public_path__ + "static/media/shuangqian22.c06b7ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medals/shuangqian22.png
// module id = 553
// module chunks = 6